module.exports = __webpack_public_path__ + "img/icon_wechat.29460a63.svg";